if (!customElements.get('ee-reviews-experts-carousel')) {
  customElements.define(
    'ee-reviews-experts-carousel',
    class EeReviewsExpertsCarousel extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;

        this.index = 0;
        this.position = 0;
        this.animating = false;
        this.onPrev = this.prev.bind(this);
        this.onNext = this.next.bind(this);
        this.onPointerDown = this.handlePointerDown.bind(this);
        this.onPointerUp = this.handlePointerUp.bind(this);
        this.onPointerCancel = this.handlePointerCancel.bind(this);
        this.onTransitionEnd = this.handleTransitionEnd.bind(this);
        this.onResize = this.handleResize.bind(this);
        this.onDotClick = this.handleDotClick.bind(this);

        this.viewport = this.querySelector('[data-rhe-viewport]');
        this.track = this.querySelector('[data-rhe-track]');
        this.dotsRoot = this.querySelector('[data-rhe-dots]');
        this.prevBtns = Array.from(this.closest('.ee-reviews-experts').querySelectorAll('[data-rhe-prev]'));
        this.nextBtns = Array.from(this.closest('.ee-reviews-experts').querySelectorAll('[data-rhe-next]'));
        this.realSlides = this.track ? Array.from(this.track.children) : [];
        this.total = this.realSlides.length;

        if (!this.viewport || !this.track || !this.total) return;

        this.realSlides.forEach(function (slide, index) {
          slide.setAttribute('data-rhe-index', String(index));
        });

        this.setupDots();

        this.prevBtns.forEach(
          function (btn) {
            btn.addEventListener('click', this.onPrev);
          }.bind(this)
        );
        this.nextBtns.forEach(
          function (btn) {
            btn.addEventListener('click', this.onNext);
          }.bind(this)
        );
        this.viewport.addEventListener('pointerdown', this.onPointerDown);
        this.viewport.addEventListener('pointerup', this.onPointerUp);
        this.viewport.addEventListener('pointercancel', this.onPointerCancel);
        this.track.addEventListener('transitionend', this.onTransitionEnd);
        window.addEventListener('resize', this.onResize);

        this.goTo(0, true);
        this.classList.add('is-ready');
        this.ready = true;
      }

      disconnectedCallback() {
        this.prevBtns.forEach(
          function (btn) {
            btn.removeEventListener('click', this.onPrev);
          }.bind(this)
        );
        this.nextBtns.forEach(
          function (btn) {
            btn.removeEventListener('click', this.onNext);
          }.bind(this)
        );
        if (this.viewport) {
          this.viewport.removeEventListener('pointerdown', this.onPointerDown);
          this.viewport.removeEventListener('pointerup', this.onPointerUp);
          this.viewport.removeEventListener('pointercancel', this.onPointerCancel);
          this.viewport.classList.remove('is-grabbing');
        }
        if (this.track) this.track.removeEventListener('transitionend', this.onTransitionEnd);
        if (this.dotsRoot) this.dotsRoot.removeEventListener('click', this.onDotClick);
        window.removeEventListener('resize', this.onResize);
        this.ready = false;
      }

      setupDots() {
        if (!this.dotsRoot) return;
        this.dotsRoot.innerHTML = '';
        for (var i = 0; i < this.total; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ee-reviews-experts__dot';
          dot.setAttribute('data-rhe-dot', String(i));
          dot.setAttribute('aria-label', 'Go to review ' + (i + 1));
          this.dotsRoot.appendChild(dot);
        }
        this.dotsRoot.addEventListener('click', this.onDotClick);
      }

      clamp(index) {
        return Math.max(0, Math.min(index, this.total - 1));
      }

      isMobile() {
        return window.matchMedia('(max-width: 749px)').matches;
      }

      prev(event) {
        if (event) event.preventDefault();
        if (this.animating || this.index <= 0) return;
        this.goTo(this.index - 1);
      }

      next(event) {
        if (event) event.preventDefault();
        if (this.animating || this.index >= this.total - 1) return;
        this.goTo(this.index + 1);
      }

      handleDotClick(event) {
        var dot = event.target.closest('[data-rhe-dot]');
        if (!dot) return;
        this.goTo(Number(dot.getAttribute('data-rhe-dot')));
      }

      handlePointerDown(event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.pointerX = event.clientX;
        this.viewport.classList.add('is-grabbing');
        if (this.viewport.setPointerCapture) this.viewport.setPointerCapture(event.pointerId);
      }

      handlePointerUp(event) {
        this.viewport.classList.remove('is-grabbing');
        if (typeof this.pointerX !== 'number') return;
        var delta = event.clientX - this.pointerX;
        this.pointerX = null;
        if (Math.abs(delta) < 40) return;
        if (delta > 0) this.prev();
        else this.next();
      }

      handlePointerCancel() {
        this.pointerX = null;
        this.viewport.classList.remove('is-grabbing');
      }

      handleTransitionEnd(event) {
        if (event.target !== this.track || event.propertyName !== 'transform') return;
        this.animating = false;
      }

      handleResize() {
        this.updateTrack(true);
      }

      updateArrows() {
        var atStart = this.index <= 0;
        var atEnd = this.index >= this.total - 1;

        this.prevBtns.forEach(function (btn) {
          btn.disabled = atStart;
          btn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
        });
        this.nextBtns.forEach(function (btn) {
          btn.disabled = atEnd;
          btn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
        });
      }

      markActive() {
        var slides = this.track.querySelectorAll('.ee-reviews-experts__card');
        slides.forEach(
          function (slide, slideIndex) {
            slide.classList.toggle('is-active', slideIndex === this.position);
          }.bind(this)
        );

        if (!this.dotsRoot) return;
        this.dotsRoot.querySelectorAll('[data-rhe-dot]').forEach(
          function (dot) {
            var isActive = Number(dot.getAttribute('data-rhe-dot')) === this.index;
            dot.classList.toggle('is-active', isActive);
            dot.setAttribute('aria-current', isActive ? 'true' : 'false');
          }.bind(this)
        );
      }

      updateTrack(instant) {
        var slide = this.track.querySelector('.ee-reviews-experts__card');
        if (!slide) return;

        var styles = window.getComputedStyle(this.track);
        var gap = parseFloat(styles.columnGap) || parseFloat(styles.gap) || 0;
        var slideWidth = slide.getBoundingClientRect().width;
        var step = slideWidth + gap;
        var offset = 0;
        if (this.total > 1 && this.isMobile()) {
          offset = this.viewport.clientWidth / 2 - (this.position * step + slideWidth / 2);
        } else if (this.total > 1) {
          offset = -step * this.position;
        }

        this.track.style.transition = instant ? 'none' : '';
        this.track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
        if (instant) {
          this.track.offsetHeight;
          this.track.style.transition = '';
        }
      }

      goTo(index, silent) {
        if (!this.total) return;

        var nextIndex = this.clamp(index);
        var nextPosition = nextIndex;

        if (!silent && nextPosition !== this.position) this.animating = true;

        this.index = nextIndex;
        this.position = nextPosition;
        this.markActive();
        this.updateArrows();
        this.updateTrack(silent);
      }
    }
  );
}
